<template>
  <RouterLink
    class="link"
    :to="{ name: 'Training', query: { callResultId: props.callResultId, startDate: props.startDate, endDate: props.endDate } }"
    target="_blank"
  >
    <div class="link-container">
      <span>{{ i18n.t('training.callFb.shortTitle') }}</span>
      <BIcon>open_in_new</BIcon>
    </div>
  </RouterLink>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';

type TProps = {
  callResultId: number;
  startDate: string;
  endDate: string;
};
const props = defineProps<TProps>();

const router = useRouter();
const i18n = useI18n();
</script>

<style lang="scss" scoped>
a.link {
  cursor: pointer;
  color: $textcolor-base;
  font-size: $fontsize-100;
  text-decoration: none;
}

.link-container {
  display: flex;
  align-items: center;
  gap: $basespace-50;
}
</style>
